import React, { useState } from "react";
import { toLocalISODate } from "../lib/dates";
import { Bell, ChevronDown, Check } from "lucide-react";
import api from "../lib/api";

// Groups notifications by category; groups with unread items start expanded.
export function NotificationGroups({ notifications, onChanged }) {
  const groups = {};
  for (const n of notifications) (groups[n.category || "general"] ||= []).push(n);
  const [closed, setClosed] = useState({});
  const markOne = async (n) => { if (n.read) return; await api.post(`/notifications/${n.id}/read`).catch(() => {}); onChanged?.(); };
  const names = Object.keys(groups).sort((a, b) => groups[b].filter((n) => !n.read).length - groups[a].filter((n) => !n.read).length || a.localeCompare(b));
  if (!names.length) return <p className="text-muted-foreground">No notifications.</p>;
  return (
    <div className="space-y-3" data-testid="notification-groups">
      {names.map((cat) => {
        const items = groups[cat]; const unread = items.filter((n) => !n.read).length;
        const open = closed[cat] === undefined ? unread > 0 : !closed[cat];
        return (
          <section key={cat} className="glass rounded-2xl" data-testid={`notif-group-${cat}`}>
            <button onClick={() => setClosed((c) => ({ ...c, [cat]: open }))} className="flex w-full items-center gap-2 px-4 py-3 text-left" aria-expanded={open} data-testid={`notif-group-toggle-${cat}`}>
              <ChevronDown size={16} className={`text-gold transition-transform ${open ? "" : "-rotate-90"}`} />
              <span className="font-serif-display text-lg font-bold capitalize text-crimson">{cat}</span>
              <span className="font-mono-accent text-xs text-muted-foreground">({items.length})</span>
              {unread > 0 && <span className="ml-auto rounded-full bg-crimson px-2 py-0.5 text-xs font-bold text-parchment" data-testid={`notif-group-unread-${cat}`}>{unread} new</span>}
            </button>
            {open && (
              <div className="space-y-2 px-4 pb-4">
                {items.map((n) => (
                  <div key={n.id} className={`rounded-lg border p-3 ${n.read ? "border-gold/15 bg-parchment-card" : "border-gold/40 bg-gold-light"}`} data-testid={`notif-${n.id}`}>
                    <div className="flex flex-wrap items-center gap-2"><Bell size={14} className="shrink-0 text-crimson" /><span className="min-w-0 flex-1 break-words font-semibold">{n.title}</span>
                      <span className="ml-auto text-[10px] text-muted-foreground">{toLocalISODate(n.created_at)}</span>
                      {!n.read && <button onClick={() => markOne(n)} className="inline-flex min-h-[36px] items-center gap-1 rounded-md px-2 py-1 text-xs text-palm hover:bg-palm/10" data-testid={`notif-read-${n.id}`}><Check size={12} /> Mark read</button>}
                    </div>
                    <p className="mt-1 text-sm text-muted-foreground">{n.body}</p>
                  </div>
                ))}
              </div>
            )}
          </section>
        );
      })}
    </div>
  );
}
